"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.injectManifestPluginDefinition = void 0;
// import utils from '../../utils/locales';
// import LocalizationContext from '../localization-context/localization-context';
const lodash_1 = require("lodash");
function findManifestPluginInstance(boutikMultilocalePlugin) {
    const { store, reporter, options } = boutikMultilocalePlugin;
    const injectionMode = options.injectManifestPluginDefinition;
    if (injectionMode !== true && injectionMode !== 'auto') {
        reporter.verbose(`Injection of localized values into plugin 'gatsby-plugin-manifest' is disabled ` +
            `(injectManifestPluginDefinition = '${injectionMode}')`);
        return;
    }
    const plugins = store.getState().flattenedPlugins;
    const manifestPluginInstances = plugins.filter((plugin) => plugin.name === 'gatsby-plugin-manifest');
    if (manifestPluginInstances.length === 0) {
        if (injectionMode === 'auto') {
            reporter.verbose(`Skipping injection of localized values into plugin 'gatsby-plugin-manifest'
                              because no instance of this plugin was found.`);
        }
        else {
            reporter.error(`Injection of localized values into plugin 'gatsby-plugin-manifest' was
                            explicitely requested (that is, 'injectManifestPluginDefinition' is set
                            to true), but no instance of plugin 'gatsby-plugin-manifest' was found.
                            Please add plugin 'gatsby-plugin-manifest' in your gatsby-config.js file.`);
        }
        return null;
    }
    reporter.verbose(`Injection of localized values into plugin 'gatsby-plugin-manifest' will be performed.`);
    if (manifestPluginInstances.length > 1)
        reporter.warn(`More than one instance of plugin 'gatsby-plugin-manifest' is present.
                       Only one of them will be injected. Resulting behavior is unpredicatable.`);
    return manifestPluginInstances[0];
}
function buildLocalizedManifestPluginDefinition(localizationContext, baseManifestOptions) {
    const localizationEntries = (0, lodash_1.mapValues)(localizationContext.locales, (locale) => {
        return {
            lang: locale.bcp47LocaleCode,
            start_url: locale.basePath, // Note that this can't be anything else, really.
            // gatsby-plugin-manifest currently identify the correct manifest
            // for a given page by checking if that page's url start with
            // the start_url of that manifest...
            name: locale.t('name', {
                ns: 'webmanifest',
                defaultValue: undefined,
            }),
            short_name: locale.t('short_name', {
                ns: 'webmanifest',
                defaultValue: undefined,
            }),
            description: locale.t('description', {
                ns: 'webmanifest',
                defaultValue: undefined,
            }),
        };
    });
    const _a = localizationEntries, _b = localizationContext.defaultLocale, defaultLocaleEntry = _a[_b], otherLocaleEntries = __rest(_a, [typeof _b === "symbol" ? _b : _b + ""]);
    const injectedPluginOptions = Object.assign(Object.assign(Object.assign({}, baseManifestOptions), defaultLocaleEntry), { localize: [...(0, lodash_1.values)(otherLocaleEntries)] });
    return injectedPluginOptions;
}
function injectManifestPluginDefinition(multilocalePlugin) {
    const manifestPluginInstance = findManifestPluginInstance(multilocalePlugin);
    if (manifestPluginInstance == null)
        return;
    manifestPluginInstance.pluginOptions =
        buildLocalizedManifestPluginDefinition(multilocalePlugin.localizationContext, manifestPluginInstance.pluginOptions);
}
exports.injectManifestPluginDefinition = injectManifestPluginDefinition;
//# sourceMappingURL=inject-manifest-plugin-definition.js.map